import React from "react";
import { Trans } from "react-i18next";
import i18next from "i18next";

import {
  Classes,
  Tag,
  Button,
  Callout,
  MultistepDialog,
  DialogStep,
  NumericInput,
  InputGroup,
  FormGroup,
  Radio,
  RadioGroup,
  Icon,
} from "@blueprintjs/core";
import { DateInput3, DateRangeInput3 } from "@blueprintjs/datetime2";

import {
  authenticatedGetFetch,
  authenticatedPostFetch,
} from "../../../../utils/AuthenticatedFetch";
import Show, { deviceLabel } from "./Show";
import EquipmentListSelect from "../../../Structure/EquipmentSelector";
import PriceInput from "../../../../utils/PriceInput";

export default class ShowCreator extends React.Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      new_be_start_date: undefined,
      new_be_end_date: undefined,
      new_bs_start_date: undefined,
      new_bs_end_date: undefined,
      new_ca_start_date: undefined,
      new_ca_end_date: undefined,
      durationBE: "auto",
      show: {
        name: "",
        start_date: undefined,
        end_date: undefined,
        flat_fare: 0,
        delay_after_show: 0,
        entry_gate: {
          closed: [],
          full_open: [],
          free_payment: [],
          flat_fare_payment: [],
          start_date: undefined,
          end_date: undefined,
        },
        exit_gate: {
          closed: [],
          full_open: [],
          free_payment: [],
          flat_fare_payment: [],
          start_date: undefined,
          end_date: undefined,
        },
        automatic_pay_machine: {
          closed: [],
          flat_fare_payment: [],
          start_date: undefined,
          end_date: undefined,
        },
        pedestrian_reader: {
          closed: [],
          full_open: [],
          start_date: undefined,
          end_date: undefined,
        },
      },
    };
  }

  componentDidUpdate() {
    if (this.state.srv !== this.props.srv)
      this.setState({ srv: this.props.srv }, () => {
        authenticatedGetFetch(
          "/devices/bytype?srvfilter=" + this.props.srv,
          (response) => {
            this.setState({
              durationBE: "auto",
              devicePreset: response,
              show: {
                name: "",
                start_date: undefined,
                end_date: undefined,
                flat_fare: 0,
                delay_after_show: 0,
                entry_gate: {
                  closed: [],
                  full_open: [],
                  free_payment: [],
                  flat_fare_payment: response["BE"] || [],
                  start_date: undefined,
                  end_date: undefined,
                },
                exit_gate: {
                  closed: [],
                  full_open: response["BS"] || [],
                  free_payment: [],
                  flat_fare_payment: [],
                  start_date: undefined,
                  end_date: undefined,
                },
                automatic_pay_machine: {
                  closed: [],
                  flat_fare_payment: [],
                  start_date: undefined,
                  end_date: undefined,
                },
                pedestrian_reader: {
                  closed: [],
                  full_open: [],
                  start_date: undefined,
                  end_date: undefined,
                },
              },
            });
          }
        );
      });
  }

  ifDateIsEgale(date1, date2){
    let newDate1 = date1
    if(typeof date1 === 'string'){
      newDate1 =  new Date(date1)
    }

    let newDate2 = date2
    if(typeof date2 === 'string'){
      newDate2 =  new Date(date2)
    }
    
    return newDate1.getTime() === newDate2.getTime();
  }


  render() {
    return (
      <div>
        <Button
          icon="add"
          text={<Trans>add a show</Trans>}
          onClick={() =>
            this.setState({
              isOpen: true,
              show: {
                name: "",
                start_date: undefined,
                end_date: undefined,
                flat_fare: 0,
                delay_after_show: 0,
                entry_gate: {
                  closed: [],
                  full_open: [],
                  free_payment: [],
                  flat_fare_payment: this.state.devicePreset["BE"],
                  start_date: undefined,
                  end_date: undefined,
                },
                exit_gate: {
                  closed: [],
                  full_open: this.state.devicePreset["BS"],
                  free_payment: [],
                  flat_fare_payment: [],
                  start_date: undefined,
                  end_date: undefined,
                },
                automatic_pay_machine: {
                  closed: [],
                  flat_fare_payment: [],
                  start_date: undefined,
                  end_date: undefined,
                },
                pedestrian_reader: {
                  closed: [],
                  full_open: [],
                  start_date: undefined,
                  end_date: undefined,
                },
              },
              durationBE: "auto",
              durationBS: "auto",
              durationLP: "auto",
              durationCA: "auto",
            })
          }
        />
        <MultistepDialog
          isOpen={this.state.isOpen}
          onClose={() => this.setState({ isOpen: false })}
          title={<Trans>add a show</Trans>}
          nextButtonProps={{ text: <Trans>next</Trans> }}
          backButtonProps={{ text: <Trans>back</Trans> }}
          closeButtonProps={{ text: <Trans>close</Trans> }}
          finalButtonProps={{
            text: <Trans>send</Trans>,
            onClick: () =>
              authenticatedPostFetch(
                "/tarif/show?srv=" + this.props.srv,
                {
                  show: this.state.show,
                },
                () =>
                  this.setState({ isOpen: false }, () => this.props.onChange())
              ),
          }}
        >
          {/* dates */}
          <DialogStep
            id="date"
            title={<Trans>dates</Trans>}
            nextButtonProps={{
              disabled:
                this.state.show.name.length === 0 ||
                this.state.show.start_date === undefined ||
                this.state.show.end_date === undefined ||
                this.ifDateIsEgale(this.state.show.start_date, this.state.show.end_date),
            }}
            panel={
              <div className={Classes.DIALOG_BODY}>
                <FormGroup
                  label={<Trans>show name</Trans>}
                  labelFor="name-input"
                  inline={true}
                >
                  <InputGroup
                    id="name-input"
                    value={this.state.show.name}
                    maxLength={22}
                    onChange={(txt) =>
                      this.setState({
                        show: { ...this.state.show, name: txt.target.value },
                      })
                    }
                    intent={
                      this.state.show.name.length === 0 ? "danger" : "success"
                    }
                  />
                </FormGroup>

                <FormGroup
                  label={<Trans>start date:</Trans>}
                  labelFor="start_date"
                  inline={true}
                >
                  <DateInput3
                    id="start_date"
                    value={this.state.show.start_date}
                    minDate={new Date()}
                    timePrecision="minute"
                    formatDate={(date) => date.toLocaleString(i18next.language)}
                    parseDate={(str) => new Date(str)}
                    onChange={(selectedDate) =>
                      this.setState({
                        new_be_start_date: this.state.new_be_start_date || selectedDate,
                        new_bs_start_date: this.state.new_bs_start_date || selectedDate,
                        new_ca_start_date: this.state.new_ca_start_date || selectedDate,
                        durationBE: "auto",
                        durationBS: "auto",
                        durationLP: "auto",
                        durationCA: "auto",
                        show: { ...this.state.show, 
                          start_date: selectedDate,
                          entry_gate: {...this.state.show.entry_gate, start_date: selectedDate},
                          exit_gate: {...this.state.show.exit_gate, start_date: selectedDate},
                          automatic_pay_machine: {...this.state.show.automatic_pay_machine, start_date: selectedDate},
                          pedestrian_reader: {...this.state.show.pedestrian_reader, start_date: selectedDate},
                        },
                      })
                    }
                    showTimezoneSelect={false}
                    locale={i18next.language}
                    closeOnSelection={false}
                  />
                </FormGroup>

                <FormGroup
                  label={<Trans>end date:</Trans>}
                  labelFor="end_date"
                  inline={true}
                >
                  <DateInput3
                    id="end_date"
                    value={this.state.show.end_date}
                    minDate={new Date()}
                    timePrecision="minute"
                    formatDate={(date) => date.toLocaleString(i18next.language)}
                    parseDate={(str) => new Date(str)}
                    onChange={(selectedDate) =>
                      this.setState({
                        new_be_end_date: this.state.new_be_end_date || selectedDate,
                        new_bs_end_date: this.state.new_bs_end_date || selectedDate,
                        new_ca_end_date: this.state.new_ca_end_date || selectedDate,
                        durationBE: "auto",
                        durationBS: "auto",
                        durationLP: "auto",
                        durationCA: "auto",
                        show: { ...this.state.show, 
                          end_date: selectedDate,
                          entry_gate: {...this.state.show.entry_gate, end_date: selectedDate},
                          exit_gate: {...this.state.show.exit_gate, end_date: selectedDate},
                          automatic_pay_machine: {...this.state.show.automatic_pay_machine, end_date: selectedDate},
                          pedestrian_reader: {...this.state.show.pedestrian_reader, end_date: selectedDate},
                        },
                      })
                    }
                    showTimezoneSelect={false}
                    locale={i18next.language}
                    closeOnSelection={false}
                  />
                </FormGroup>
                <Callout intent="warning">
                  <Trans>
                    show fare configuration will be loaded by the devices at
                    next reboot (usually scheduled during night)
                  </Trans>
                </Callout>
              </div>
            }
          />

          {/* pricing */}
          <DialogStep
            id="price"
            title={<Trans>price</Trans>}
            nextButtonProps={{
              disabled:
                this.state.show.flat_fare <= 0 ||
                this.state.show.delay_after_show < 0,
            }}
            panel={
              <div className={Classes.DIALOG_BODY}>
                <Callout>
                  <Trans>flat fare during the manifestation</Trans>
                </Callout>

                <PriceInput
                  label={<Trans>flat fare</Trans>}
                  defaultValue={this.state.show.flat_fare}
                  onValueChange={(price) => {
                    this.setState({
                      show: { ...this.state.show, flat_fare: price },
                    });
                  }}
                />

                <FormGroup
                  label={<Trans>delay after show:</Trans>}
                  labelFor="delay"
                  inline={false}
                >
                  <NumericInput
                    value={this.state.show.delay_after_show}
                    id="delay"
                    min={0}
                    max={1000}
                    stepSize={1}
                    rightElement={
                      <Tag>
                        <Icon icon="time" />
                      </Tag>
                    }
                    onValueChange={(delay) => {
                      if (delay >= 0)
                        this.setState({
                          show: { ...this.state.show, delay_after_show: delay },
                        });
                    }}
                    intent={
                      this.state.show.delay_after_show < 0
                        ? "danger"
                        : "success"
                    }
                  />
                </FormGroup>
              </div>
            }
          />

          {/* entry terminals */}
          <DialogStep
            id="entry"
            title={<Trans>E</Trans>}
            nextButtonProps={{
              disabled: (this.state.show.entry_gate.end_date === undefined || this.state.show.entry_gate.end_date === null ||
                this.state.show.entry_gate.start_date === undefined || this.state.show.entry_gate.start_date === null) ||
                this.ifDateIsEgale(this.state.show.entry_gate.start_date, this.state.show.entry_gate.end_date),
            }}
            panel={
              <div className={Classes.DIALOG_BODY}>
                <Callout>
                  <Trans>flat beh BE</Trans>
                </Callout>
                <Callout intent="primary">
                  <Trans>flat default BE</Trans>
                </Callout>
                <div className="flexbox-left">
                  <Trans>closed</Trans> :
                  <EquipmentListSelect
                    key="bec"
                    type="BE"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          entry_gate: {
                            ...this.state.show.entry_gate,
                            closed: [
                              ...this.state.show.entry_gate.closed,
                              deviceId,
                            ],
                            full_open:
                              this.state.show.entry_gate.full_open.filter(
                                (i) => i !== deviceId
                              ),
                            free_payment:
                              this.state.show.entry_gate.free_payment.filter(
                                (i) => i !== deviceId
                              ),
                            flat_fare_payment:
                              this.state.show.entry_gate.flat_fare_payment.filter(
                                (i) => i !== deviceId
                              ),
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(this.state.show.entry_gate.closed || []).map(
                      (device, index) => (
                        <Tag
                          key={index}
                          onRemove={() =>
                            this.setState({
                              show: {
                                ...this.state.show,
                                entry_gate: {
                                  ...this.state.show.entry_gate,
                                  closed:
                                    this.state.show.entry_gate.closed.filter(
                                      (i) => i !== device
                                    ),
                                },
                              },
                            })
                          }
                        >
                          {deviceLabel(this.props.devices_def, device)}
                        </Tag>
                      )
                    )}
                  </div>
                </div>

                <div className="flexbox-left">
                  <Trans>OBM</Trans> :
                  <EquipmentListSelect
                    key="befo"
                    type="BE"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          entry_gate: {
                            ...this.state.show.entry_gate,
                            closed: this.state.show.entry_gate.closed.filter(
                              (i) => i !== deviceId
                            ),
                            full_open: [
                              ...this.state.show.entry_gate.full_open,
                              deviceId,
                            ],
                            free_payment:
                              this.state.show.entry_gate.free_payment.filter(
                                (i) => i !== deviceId
                              ),
                            flat_fare_payment:
                              this.state.show.entry_gate.flat_fare_payment.filter(
                                (i) => i !== deviceId
                              ),
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(this.state.show.entry_gate.full_open || []).map(
                      (device, index) => (
                        <Tag
                          key={index}
                          onRemove={() =>
                            this.setState({
                              show: {
                                ...this.state.show,
                                entry_gate: {
                                  ...this.state.show.entry_gate,
                                  full_open:
                                    this.state.show.entry_gate.full_open.filter(
                                      (i) => i !== device
                                    ),
                                },
                              },
                            })
                          }
                        >
                          {deviceLabel(this.props.devices_def, device)}
                        </Tag>
                      )
                    )}
                  </div>
                </div>

                <div className="flexbox-left">
                  <Trans>free payment</Trans> :
                  <EquipmentListSelect
                    key="befp"
                    type="BE"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          entry_gate: {
                            ...this.state.show.entry_gate,
                            closed: this.state.show.entry_gate.closed.filter(
                              (i) => i !== deviceId
                            ),
                            full_open:
                              this.state.show.entry_gate.full_open.filter(
                                (i) => i !== deviceId
                              ),
                            free_payment: [
                              ...this.state.show.entry_gate.free_payment,
                              deviceId,
                            ],
                            flat_fare_payment:
                              this.state.show.entry_gate.flat_fare_payment.filter(
                                (i) => i !== deviceId
                              ),
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(this.state.show.entry_gate.free_payment || []).map(
                      (device, index) => (
                        <Tag
                          key={index}
                          onRemove={() =>
                            this.setState({
                              show: {
                                ...this.state.show,
                                entry_gate: {
                                  ...this.state.show.entry_gate,
                                  free_payment:
                                    this.state.show.entry_gate.free_payment.filter(
                                      (i) => i !== device
                                    ),
                                },
                              },
                            })
                          }
                        >
                          {deviceLabel(this.props.devices_def, device)}
                        </Tag>
                      )
                    )}
                  </div>
                </div>

                <div className="flexbox-left">
                  <Trans>flat fare payment</Trans> :
                  <EquipmentListSelect
                    key="beff"
                    type="BE"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          entry_gate: {
                            ...this.state.show.entry_gate,
                            closed: this.state.show.entry_gate.closed.filter(
                              (i) => i !== deviceId
                            ),
                            full_open:
                              this.state.show.entry_gate.full_open.filter(
                                (i) => i !== deviceId
                              ),
                            free_payment:
                              this.state.show.entry_gate.free_payment.filter(
                                (i) => i !== deviceId
                              ),
                            flat_fare_payment: [
                              ...this.state.show.entry_gate.flat_fare_payment,
                              deviceId,
                            ],
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(this.state.show.entry_gate.flat_fare_payment || []).map(
                      (device, index) => (
                        <Tag
                          key={index}
                          onRemove={() =>
                            this.setState({
                              show: {
                                ...this.state.show,
                                entry_gate: {
                                  ...this.state.show.entry_gate,
                                  flat_fare_payment:
                                    this.state.show.entry_gate.flat_fare_payment.filter(
                                      (i) => i !== device
                                    ),
                                },
                              },
                            })
                          }
                        >
                          {deviceLabel(this.props.devices_def, device)}
                        </Tag>
                      )
                    )}
                  </div>
                </div>

                <RadioGroup
                  label={<Trans>applicable for</Trans>}
                  onChange={(event) =>
                    this.setState({
                      durationBE: event.target.value,
                      show: {
                        ...this.state.show,
                        entry_gate: {
                          ...this.state.show.entry_gate,
                          start_date: event.target.value === "custom" ? this.state.new_be_start_date : this.state.show.start_date,
                          end_date: event.target.value === "custom" ? this.state.new_be_end_date : this.state.show.end_date,
                        },
                      },
                    })
                  }
                  selectedValue={this.state.durationBE}
                >
                  <Radio
                    label={<Trans>the duration of the event</Trans>}
                    value="auto"
                  />
                  <Radio
                    label={<Trans>a custom duration</Trans>}
                    value="custom"
                  />
                </RadioGroup>
                {this.state.durationBE === "custom" && (
                  <DateRangeInput3
                    minDate={new Date(this.state.show.start_date)}
                    maxDate={new Date(this.state.show.end_date)}
                    allowSingleDayRange={true}
                    timePrecision="minute"
                    shortcuts={false}
                    formatDate={(date) => date.toLocaleString(i18next.language)}
                    parseDate={(str) => new Date(str)}
                    value={[
                      new Date(this.state.new_be_start_date),
                      new Date(this.state.new_be_end_date),
                    ]}
                    onChange={(dateRange)=>{
                      this.setState({
                        new_be_start_date: dateRange[0],
                        new_be_end_date: dateRange[1],
                        show: {
                          ...this.state.show,
                          entry_gate: {
                            ...this.state.show.entry_gate,
                            start_date: dateRange[0],
                            end_date: dateRange[1],
                          },
                        },
                      });
                    } }
                  />
                )}
              </div>
            }
          />

          {/* payment stations */}
          <DialogStep
            id="paymentstation"
            title={<Trans>C</Trans>}
            nextButtonProps={{
              disabled:
                (this.state.show.automatic_pay_machine.end_date === undefined ||this.state.show.automatic_pay_machine.end_date === null ||
                this.state.show.automatic_pay_machine.start_date === undefined || this.state.show.automatic_pay_machine.start_date === null) ||
                this.ifDateIsEgale(this.state.show.automatic_pay_machine.start_date, this.state.show.automatic_pay_machine.end_date),
            }}
            panel={
              <div className={Classes.DIALOG_BODY}>
                <Callout>
                  <Trans>flat beh CA</Trans>
                </Callout>
                <Callout intent="primary">
                  <Trans>flat default CA</Trans>
                </Callout>
                <div className="flexbox-left">
                  <Trans>closed</Trans> :
                  <EquipmentListSelect
                    key="cac"
                    type="CA"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          automatic_pay_machine: {
                            ...this.state.show.automatic_pay_machine,
                            closed: [
                              ...this.state.show.automatic_pay_machine.closed,
                              deviceId,
                            ],
                            flat_fare_payment:
                              this.state.show.automatic_pay_machine.flat_fare_payment.filter(
                                (i) => i !== deviceId
                              ),
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(this.state.show.automatic_pay_machine.closed || []).map(
                      (device, index) => (
                        <Tag
                          key={index}
                          onRemove={() =>
                            this.setState({
                              show: {
                                ...this.state.show,
                                automatic_pay_machine: {
                                  ...this.state.show.automatic_pay_machine,
                                  closed:
                                    this.state.show.automatic_pay_machine.closed.filter(
                                      (i) => i !== device
                                    ),
                                },
                              },
                            })
                          }
                        >
                          {deviceLabel(this.props.devices_def, device)}
                        </Tag>
                      )
                    )}
                  </div>
                </div>

                <div className="flexbox-left">
                  <Trans>flat fare payment</Trans> :
                  <EquipmentListSelect
                    key="caff"
                    type="CA"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          automatic_pay_machine: {
                            ...this.state.show.automatic_pay_machine,
                            closed:
                              this.state.show.automatic_pay_machine.closed.filter(
                                (i) => i !== deviceId
                              ),
                            flat_fare_payment: [
                              ...this.state.show.automatic_pay_machine
                                .flat_fare_payment,
                              deviceId,
                            ],
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(
                      this.state.show.automatic_pay_machine.flat_fare_payment ||
                      []
                    ).map((device, index) => (
                      <Tag
                        key={index}
                        onRemove={() =>
                          this.setState({
                            show: {
                              ...this.state.show,
                              automatic_pay_machine: {
                                ...this.state.show.automatic_pay_machine,
                                flat_fare_payment:
                                  this.state.show.automatic_pay_machine.flat_fare_payment.filter(
                                    (i) => i !== device
                                  ),
                              },
                            },
                          })
                        }
                      >
                        {deviceLabel(this.props.devices_def, device)}
                      </Tag>
                    ))}
                  </div>
                </div>
                <RadioGroup
                  label={<Trans>applicable for</Trans>}
                  onChange={(event) =>
                    this.setState({
                      durationCA: event.target.value,
                      show: {
                        ...this.state.show,
                        automatic_pay_machine: {
                          ...this.state.show.automatic_pay_machine,
                          start_date: event.target.value === "custom" ?  this.state.new_ca_start_date : this.state.show.start_date,
                          end_date: event.target.value === "custom" ?  this.state.new_ca_end_date : this.state.show.end_date,
                        },
                      },
                    })
                  }
                  selectedValue={this.state.durationCA}
                >
                  <Radio
                    label={<Trans>the duration of the event</Trans>}
                    value="auto"
                  />
                  <Radio
                    label={<Trans>a custom duration</Trans>}
                    value="custom"
                  />
                </RadioGroup>

                {this.state.durationCA === "custom" && (
                  <DateRangeInput3
                    minDate={new Date(this.state.show.start_date)}
                    maxDate={new Date(this.state.show.end_date)}
                    allowSingleDayRange={true}
                    timePrecision="minute"
                    shortcuts={false}
                    formatDate={(date) => date.toLocaleString(i18next.language)}
                    parseDate={(str) => new Date(str)}
                    value={[
                      new Date(this.state.new_ca_start_date),
                        new Date(this.state.new_ca_end_date),
                    ]}
                    onChange={(dateRange) =>
                      this.setState({
                        new_ca_start_date: dateRange[0],
                        new_ca_end_date: dateRange[1],
                        show: {
                          ...this.state.show,
                          automatic_pay_machine: {
                            ...this.state.show.automatic_pay_machine,
                            start_date: dateRange[0],
                            end_date: dateRange[1],
                          },
                        },
                      })
                    }
                  />
                )}
              </div>
            }
          />

          {/* exit terminals */}
          <DialogStep
            id="exit"
            title={<Trans>S</Trans>}
            nextButtonProps={{
              disabled: (this.state.show.exit_gate.end_date === undefined || this.state.show.exit_gate.start_date === null
                || this.state.show.exit_gate.end_date === undefined || this.state.show.exit_gate.start_date === null) ||
                this.ifDateIsEgale(this.state.show.exit_gate.start_date, this.state.show.exit_gate.end_date),
            }}
            panel={
              <div className={Classes.DIALOG_BODY}>
                <Callout>
                  <Trans>flat beh BS</Trans>
                </Callout>
                <Callout intent="primary">
                  <Trans>flat default BS</Trans>
                </Callout>
                <div className="flexbox-left">
                  <Trans>closed</Trans> :
                  <EquipmentListSelect
                    key="bsc"
                    type="BS"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          exit_gate: {
                            ...this.state.show.exit_gate,
                            closed: [
                              ...this.state.show.exit_gate.closed,
                              deviceId,
                            ],
                            full_open:
                              this.state.show.exit_gate.full_open.filter(
                                (i) => i !== deviceId
                              ),
                            free_payment:
                              this.state.show.exit_gate.free_payment.filter(
                                (i) => i !== deviceId
                              ),
                            flat_fare_payment:
                              this.state.show.exit_gate.flat_fare_payment.filter(
                                (i) => i !== deviceId
                              ),
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(this.state.show.exit_gate.closed || []).map(
                      (device, index) => (
                        <Tag
                          key={index}
                          onRemove={() =>
                            this.setState({
                              show: {
                                ...this.state.show,
                                exit_gate: {
                                  ...this.state.show.exit_gate,
                                  closed:
                                    this.state.show.exit_gate.closed.filter(
                                      (i) => i !== device
                                    ),
                                },
                              },
                            })
                          }
                        >
                          {deviceLabel(this.props.devices_def, device)}
                        </Tag>
                      )
                    )}
                  </div>
                </div>

                <div className="flexbox-left">
                  <Trans>OBM</Trans> :
                  <EquipmentListSelect
                    key="bsfo"
                    type="BS"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          exit_gate: {
                            ...this.state.show.exit_gate,
                            closed: this.state.show.exit_gate.closed.filter(
                              (i) => i !== deviceId
                            ),
                            full_open: [
                              ...this.state.show.exit_gate.full_open,
                              deviceId,
                            ],
                            free_payment:
                              this.state.show.exit_gate.free_payment.filter(
                                (i) => i !== deviceId
                              ),
                            flat_fare_payment:
                              this.state.show.exit_gate.flat_fare_payment.filter(
                                (i) => i !== deviceId
                              ),
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(this.state.show.exit_gate.full_open || []).map(
                      (device, index) => (
                        <Tag
                          key={index}
                          onRemove={() =>
                            this.setState({
                              show: {
                                ...this.state.show,
                                exit_gate: {
                                  ...this.state.show.exit_gate,
                                  full_open: (
                                    this.state.show.exit_gate.full_open || []
                                  ).filter((i) => i !== device),
                                },
                              },
                            })
                          }
                        >
                          {deviceLabel(this.props.devices_def, device)}
                        </Tag>
                      )
                    )}
                  </div>
                </div>

                <div className="flexbox-left">
                  <Trans>free payment</Trans> :
                  <EquipmentListSelect
                    key="bsfp"
                    type="BS"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          exit_gate: {
                            ...this.state.show.exit_gate,
                            closed: this.state.show.exit_gate.closed.filter(
                              (i) => i !== deviceId
                            ),
                            full_open:
                              this.state.show.exit_gate.full_open.filter(
                                (i) => i !== deviceId
                              ),
                            free_payment: [
                              ...this.state.show.exit_gate.free_payment,
                              deviceId,
                            ],
                            flat_fare_payment:
                              this.state.show.exit_gate.flat_fare_payment.filter(
                                (i) => i !== deviceId
                              ),
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(this.state.show.exit_gate.free_payment || []).map(
                      (device, index) => (
                        <Tag
                          key={index}
                          onRemove={() =>
                            this.setState({
                              show: {
                                ...this.state.show,
                                exit_gate: {
                                  ...this.state.show.exit_gate,
                                  free_payment:
                                    this.state.show.exit_gate.free_payment.filter(
                                      (i) => i !== device
                                    ),
                                },
                              },
                            })
                          }
                        >
                          {deviceLabel(this.props.devices_def, device)}
                        </Tag>
                      )
                    )}
                  </div>
                </div>

                <div className="flexbox-left">
                  <Trans>flat fare payment</Trans> :
                  <EquipmentListSelect
                    key="bsff"
                    type="BS"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          exit_gate: {
                            ...this.state.show.exit_gate,
                            closed: this.state.show.exit_gate.closed.filter(
                              (i) => i !== deviceId
                            ),
                            full_open:
                              this.state.show.exit_gate.full_open.filter(
                                (i) => i !== deviceId
                              ),
                            free_payment:
                              this.state.show.exit_gate.free_payment.filter(
                                (i) => i !== deviceId
                              ),
                            flat_fare_payment: [
                              ...this.state.show.exit_gate.flat_fare_payment,
                              deviceId,
                            ],
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(this.state.show.exit_gate.flat_fare_payment || []).map(
                      (device, index) => (
                        <Tag
                          key={index}
                          onRemove={() =>
                            this.setState({
                              show: {
                                ...this.state.show,
                                exit_gate: {
                                  ...this.state.show.exit_gate,
                                  flat_fare_payment:
                                    this.state.show.exit_gate.flat_fare_payment.filter(
                                      (i) => i !== device
                                    ),
                                },
                              },
                            })
                          }
                        >
                          {deviceLabel(this.props.devices_def, device)}
                        </Tag>
                      )
                    )}
                  </div>
                </div>

                <RadioGroup
                  label={<Trans>applicable for</Trans>}
                  onChange={(event) =>
                    this.setState({
                      durationBS: event.target.value,
                      show: {
                        ...this.state.show,
                        exit_gate: {
                          ...this.state.show.exit_gate,
                          start_date: event.target.value === "custom" ? this.state.new_bs_start_date : this.state.show.start_date,
                          end_date: event.target.value === "custom" ? this.state.new_bs_end_date : this.state.show.end_date,
                        },
                      },
                    })
                  }
                  selectedValue={this.state.durationBS}
                >
                  <Radio
                    label={<Trans>the duration of the event</Trans>}
                    value="auto"
                  />
                  <Radio
                    label={<Trans>a custom duration</Trans>}
                    value="custom"
                  />
                </RadioGroup>
                {this.state.durationBS === "custom" && (
                  <DateRangeInput3
                    minDate={new Date(this.state.show.start_date)}
                    maxDate={new Date(this.state.show.end_date)}
                    allowSingleDayRange={true}
                    timePrecision="minute"
                    shortcuts={false}
                    formatDate={(date) => date.toLocaleString(i18next.language)}
                    parseDate={(str) => new Date(str)}
                    value={[
                      new Date(this.state.new_bs_start_date),
                      new Date(this.state.new_bs_end_date),
                    ]}
                    onChange={(dateRange) =>
                      this.setState({
                        new_bs_start_date: dateRange[0],
                        new_bs_end_date: dateRange[1],
                        show: {
                          ...this.state.show,
                          exit_gate: {
                            ...this.state.show.exit_gate,
                            start_date: dateRange[0],
                            end_date: dateRange[1],
                          },
                        },
                      })
                    }
                  />
                )}
              </div>
            }
          />

          {/* pedestrian access */}
          <DialogStep
            id="pedestrian"
            title={<Trans>LP</Trans>}
            nextButtonProps={{
              disabled:
                (this.state.show.pedestrian_reader.end_date === undefined ||this.state.show.pedestrian_reader.end_date === null ||
                  this.state.show.pedestrian_reader.start_date === undefined || this.state.show.pedestrian_reader.start_date === null) ||
                  this.ifDateIsEgale(this.state.show.pedestrian_reader.start_date, this.state.show.pedestrian_reader.end_date),
            }}
            panel={
              <div className={Classes.DIALOG_BODY}>
                <Callout>
                  <Trans>flat beh LP</Trans>
                </Callout>
                <Callout intent="primary">
                  <Trans>flat default LP</Trans>
                </Callout>
                <div className="flexbox-left">
                  <Trans>closed</Trans> :
                  <EquipmentListSelect
                    key="lpc"
                    type="LP"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          pedestrian_reader: {
                            ...this.state.show.pedestrian_reader,
                            closed: [
                              ...this.state.show.pedestrian_reader.closed,
                              deviceId,
                            ],
                            full_open:
                              this.state.show.pedestrian_reader.full_open.filter(
                                (i) => i !== deviceId
                              ),
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(this.state.show.pedestrian_reader.closed || []).map(
                      (device, index) => (
                        <Tag
                          key={index}
                          onRemove={() =>
                            this.setState({
                              show: {
                                ...this.state.show,
                                pedestrian_reader: {
                                  ...this.state.show.pedestrian_reader,
                                  closed:
                                    this.state.show.pedestrian_reader.closed.filter(
                                      (i) => i !== device
                                    ),
                                },
                              },
                            })
                          }
                        >
                          {deviceLabel(this.props.devices_def, device)}
                        </Tag>
                      )
                    )}
                  </div>
                </div>

                <div className="flexbox-left">
                  <Trans>OBM</Trans> :
                  <EquipmentListSelect
                    key="lpfo"
                    type="LP"
                    srv={this.state.srv}
                    onSelect={(deviceId, device) =>
                      this.setState({
                        show: {
                          ...this.state.show,
                          pedestrian_reader: {
                            ...this.state.show.pedestrian_reader,
                            closed:
                              this.state.show.pedestrian_reader.closed.filter(
                                (i) => i !== deviceId
                              ),
                            full_open: [
                              ...this.state.show.pedestrian_reader.full_open,
                              deviceId,
                            ],
                          },
                        },
                      })
                    }
                  />
                  <div className="flexbox-left">
                    {(this.state.show.pedestrian_reader.full_open || []).map(
                      (device, index) => (
                        <Tag
                          key={index}
                          onRemove={() =>
                            this.setState({
                              show: {
                                ...this.state.show,
                                pedestrian_reader: {
                                  ...this.state.show.pedestrian_reader,
                                  full_open:
                                    this.state.show.pedestrian_reader.full_open.filter(
                                      (i) => i !== device
                                    ),
                                },
                              },
                            })
                          }
                        >
                          {deviceLabel(this.props.devices_def, device)}
                        </Tag>
                      )
                    )}
                  </div>
                </div>
              </div>
            }
          />

          {/* submit */}
          <DialogStep
            id="send"
            title={<Trans>send</Trans>}
            panel={
              <div className={Classes.DIALOG_BODY}>
                <Show 
                  {...this.state.show} 
                  showOnly={true}
                  device_def={this.props.devices_def}
                />
              </div>
            }
          />
        </MultistepDialog>
      </div>
    );
  }
}
